import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { StoreProvider } from "@/store/StoreContext";
import Layout from "@/components/store/Layout";
import Home from "@/pages/Home";
import Collection from "@/pages/Collection";
import Product from "@/pages/Product";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import TrackOrder from "@/pages/TrackOrder";
import Account from "@/pages/Account";
import Wishlist from "@/pages/Wishlist";
import Search from "@/pages/Search";
import CmsPage from "@/pages/CmsPage";
import { Blog, BlogPost } from "@/pages/Blog";
import NotFound from "@/pages/NotFound";
import AdminLayout from "@/admin/AdminLayout";
import Dashboard from "@/admin/Dashboard";
import AdminProducts from "@/admin/AdminProducts";
import { AdminCategories, AdminCollections } from "@/admin/AdminCategories";
import AdminOrders from "@/admin/AdminOrders";
import AdminCustomers from "@/admin/AdminCustomers";
import AdminDiscounts from "@/admin/AdminDiscounts";
import { AdminReviews, AdminNotify } from "@/admin/AdminReviews";
import AdminBanners from "@/admin/AdminBanners";
import AdminMenus from "@/admin/AdminMenus";
import AdminHomepage from "@/admin/AdminHomepage";
import { AdminPages, AdminBlog } from "@/admin/AdminPages";
import AdminInventory from "@/admin/AdminInventory";
import AdminSettings from "@/admin/AdminSettings";
import AdminSeo from "@/admin/AdminSeo";
import AdminMedia from "@/admin/AdminMedia";
import AdminUsers from "@/admin/AdminUsers";
import AdminReports from "@/admin/AdminReports";
import AdminBulk from "@/admin/AdminBulk";
import AdminSizeCharts from "@/admin/AdminSizeCharts";
import AdminSeoHealth from "@/admin/AdminSeoHealth";
import AdminVideos from "@/admin/AdminVideos";
import AdminSocial from "@/admin/AdminSocial";
import AdminBackups from "@/admin/AdminBackups";
import AdminAnimations from "@/admin/AdminAnimations";
import AdminNotifications from "@/admin/AdminNotifications";
import AdminCrm from "@/admin/AdminCrm";
import AdminCampaigns from "@/admin/AdminCampaigns";

function App() {
  return (
    <StoreProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/collections/:slug" element={<Collection />} />
            <Route path="/products/:slug" element={<Product />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/order-success/:orderNumber" element={<OrderSuccess />} />
            <Route path="/pages/track-order" element={<TrackOrder />} />
            <Route path="/pages/:slug" element={<CmsPage />} />
            <Route path="/account" element={<Account />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/search" element={<Search />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="bulk" element={<AdminBulk />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="collections" element={<AdminCollections />} />
            <Route path="size-charts" element={<AdminSizeCharts />} />
            <Route path="inventory" element={<AdminInventory />} />
            <Route path="customers" element={<AdminCustomers />} />
            <Route path="discounts" element={<AdminDiscounts />} />
            <Route path="reviews" element={<AdminReviews />} />
            <Route path="notify" element={<AdminNotify />} />
            <Route path="banners" element={<AdminBanners />} />
            <Route path="menus" element={<AdminMenus />} />
            <Route path="homepage" element={<AdminHomepage />} />
            <Route path="pages" element={<AdminPages />} />
            <Route path="blog" element={<AdminBlog />} />
            <Route path="media" element={<AdminMedia />} />
            <Route path="seo" element={<AdminSeo />} />
            <Route path="seo-health" element={<AdminSeoHealth />} />
            <Route path="videos" element={<AdminVideos />} />
            <Route path="social" element={<AdminSocial />} />
            <Route path="backups" element={<AdminBackups />} />
            <Route path="animations" element={<AdminAnimations />} />
            <Route path="notifications" element={<AdminNotifications />} />
            <Route path="customer-db" element={<AdminCrm />} />
            <Route path="campaigns" element={<AdminCampaigns />} />
            <Route path="reports" element={<AdminReports />} />
            <Route path="marketing" element={<AdminSettings section="marketing" />} />
            <Route path="payments" element={<AdminSettings section="payments" />} />
            <Route path="shipping" element={<AdminSettings section="shipping" />} />
            <Route path="settings" element={<AdminSettings section="store" />} />
            <Route path="users" element={<AdminUsers />} />
          </Route>
          <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </BrowserRouter>
    </StoreProvider>
  );
}

export default App;
